export default "__VITE_ASSET__CT6$SHLb__"